import React from 'react';
import { ClientBubble as StyledClientBubble, ClientLabel, ClientMessage } from './styles';
import userIconDecision from 'img/user-icon-decision.svg';
import { MESSAGES } from 'pages/new-questions/components/DecisionTreeQuestion/utils/constants';

interface ClientBubbleProps {
  message: string;
}

export const ClientBubble: React.FC<ClientBubbleProps> = ({ message }) => {
  return (
    <StyledClientBubble>
      <img src={userIconDecision} alt="User" />
      <div>
        <ClientLabel>{MESSAGES.CLIENT_LABEL}</ClientLabel>
        <ClientMessage dangerouslySetInnerHTML={{__html: message || ''}} />
      </div>
    </StyledClientBubble>
  );
};
